module.exports = __webpack_public_path__ + "static/media/hamburger.a4a24c87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hamburger.svg
// module id = 203
// module chunks = 0